import { render, staticRenderFns } from "./SysFornecedorPorProdutoAutocomplete.vue?vue&type=template&id=f52e834c&scoped=true"
import script from "./SysFornecedorPorProdutoAutocomplete.vue?vue&type=script&lang=js"
export * from "./SysFornecedorPorProdutoAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52e834c",
  null
  
)

export default component.exports